import { render, staticRenderFns } from "./ColorStatus.vue?vue&type=template&id=5e6ed069&"
import script from "./ColorStatus.vue?vue&type=script&lang=js&"
export * from "./ColorStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports